/**
 * reference_config.can_move_past === 1 (única fuente de verdad para store y vistas).
 *
 * @param {Object|null|undefined} product - Referencia/producto del timer (format API categories).
 * @returns {boolean}
 */
export function referenceCanMovePast (product) {
    if (!product || product.reference_config == null) {
        return false
    }
    let refCfg = product.reference_config
    if (typeof refCfg === 'string') {
        try {
            refCfg = JSON.parse(refCfg)
        } catch {
            return false
        }
    }
    if (typeof refCfg !== 'object' || refCfg === null) {
        return false
    }
    const v = refCfg.can_move_past
    return v === 1 || v === '1'
}
